import { useState, useEffect } from 'react';
import styles from './list.module.css';
import { Link, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { Typography, Button, Checkbox } from '@mui/material';
import { Plus } from 'react-feather';
import axios from 'axios';
import Modal from 'react-bootstrap/Modal';
import { TableLoader } from '../../components/LoaderC';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import Select from "react-select";
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import withAdminAuth from "../../components/withAdminAuth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const userTypeOptions = [
  { label: 'UK Admin', value: 'UK Admin' },
  { label: 'Pickup Driver', value: 'Pickup Driver' },
  { label: 'GH Admin', value: 'GH Admin' },
  { label: 'GH Driver', value: 'GH Driver' },
  { label: 'Receptionist', value: 'Receptionist' }
]

const schema = yup.object().shape({
  title: yup.string().required('This field is Required').max(50, 'Title cannot be more than 50 characters')
});

const AddPermission = ({ modalClose, addPermissionLocal }) => {
  const auth = authData();
  const API_Token = auth?.api_token;
  let { id } = useParams();
  const isAddMode = !id;
  const [contentLoading, setContentLoading] = useState(true);
  const [userPermissionParentOptions, setUserPermissionParentOptions] = useState([{ label: 'Parent', value: 0 }]);

  const { register, handleSubmit, control, watch, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: { parent: { label: 'Parent', value: 0 } }
  });

  useEffect(() => {
    if (contentLoading) {
      axios.get(process.env.REACT_APP_API_URL + 'v1/users-permission-parent-list', {
        headers: {
          Authorization: `Bearer ${API_Token}`
        }
      }).then(response => {
        setContentLoading(false);
        if (response.data.status === 'SUCCESS') {
          let itemData = response.data.data;
          let obj = userPermissionParentOptions;
          setUserPermissionParentOptions([...obj, ...itemData]);
        }
      }).catch(error => {
        setContentLoading(false);
      });
    }
  }, [isAddMode, id, setValue, contentLoading, userPermissionParentOptions, API_Token]);

  const onSubmit = async (data) => {
    addPermissionLocal(data);
  }

  return (<form onSubmit={handleSubmit(onSubmit)}>
    <div className={`${styles.FormRow}`}>
      <div className={`${styles.FormGroupFull}`}>
        <label className={`${styles.FormLabel}`}>Title*</label>
        <input {...register("title")} placeholder='Title' className={`${styles.FormControl}`} />
        {errors.title && !watch().title && <span className={`${styles.ErrorM}`}>{errors.title.message}</span>}
      </div>
    </div>
    <div className={`${styles.FormRow}`}>
      <div className={`${styles.FormGroupFull}`}>
        <label className={`${styles.FormLabel}`}>Parent</label>
        <Controller
          control={control}
          options={userPermissionParentOptions}
          {...register('parent')}
          render={({ field }) => (<Select {...field} options={userPermissionParentOptions} />)}
        />
      </div>
    </div>

    <div className={`${styles.FormButtonArea}`}>
      <Button className='PopUpCanBU' onClick={modalClose}>Cancel</Button>
      <Button className='PopUpSubmitBU' type="submit" >Add</Button>
    </div>
  </form>)
}

const UserPermissionList = ({ history, match }) => {
  const auth = authData();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    const fetchPerms = () => {
      axios(process.env.REACT_APP_API_URL + 'v1/users-permission-list', {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      }).then(response => {
        setContentLoading(false);
        if (response.data.status === 'SUCCESS') {
          setData(response.data.data);
        }
      }).catch(error => {
        setContentLoading(false);
      });
    }

    fetchPerms();
  }, [auth?.api_token]);

  const handleChange = (event, itemId, uType) => {
    if (event.target.checked) {
      axios.post(process.env.REACT_APP_API_URL + 'v1/add-role-permission', { permission_id: itemId, user_type: uType }, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + 'v1/delete-role-permission', { permission_id: itemId, user_type: uType }, {
        headers: {
          Authorization: `Bearer ${auth?.api_token}`,
        }
      });
    }
  }

  const addPermissionLocal = (data) => {
    const postData = data;
    setLoading(true);
    setModalShow(false);

    return axios.post(process.env.REACT_APP_API_URL + 'v1/users-permission-add', postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then(response => {
      setLoading(false);
      if (response.data.status === 'SUCCESS') {
        let resData = response.data.data;
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: "light",
        });

        setData(prev => {
          if (resData.parent > 0) {
            return prev.map(item => {
              if (item.id === resData.parent) {
                return { ...item, children: [...item.children, { id: resData.id, title: resData.title, parent: resData.parent, permissions: [] }] };
              }
              return item;
            });
          } else {
            return [...prev, { id: resData.id, title: resData.title, children: [] }];
          }
        });
      }
    }).catch(error => {
      setLoading(false);
    });
  }

  return (<>
    {loading && <Loader />}
    {contentLoading && <div className="LoaderCard"><div className="Loader TableLoader"><TableLoader /></div></div>}
    {!contentLoading && <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>User Permissions</p>
      </div>

      <div className={`${styles.MainCard}`}>
        <div className='TableFilterHead'>
          <Link onClick={(e) => setModalShow(true)} className="TableAddBU"><Plus /></Link>
        </div>

        {data?.map((item, index) => {
          return <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={"panel" + index + "a-content"} id={"panel" + index + "a-header"}>
              <Typography>{item.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {item?.children?.map((itemChildren, indexChildren) => {
                return (<li style={{ display: 'flex' }} key={indexChildren}>
                  <strong style={{ float: 'left', marginRight: '30px' }}>{itemChildren.title}</strong>
                  {userTypeOptions?.map((itemUSerType, indexuserType) => {
                    return (<div style={{ float: 'left' }}>
                      <span style={{ marginLeft: '20px' }}>
                        <Checkbox defaultChecked={(itemChildren.permissions.indexOf(itemUSerType.value) > -1)} onChange={(e) => handleChange(e, itemChildren.id, itemUSerType.value)} />
                        <label style={{ marginLeft: '5px' }}>{itemUSerType.value}</label>
                      </span>
                    </div>)
                  })}
                </li>)
              })}
            </AccordionDetails>
          </Accordion>
        })}
      </div>
    </div>}

    <Modal show={modalShow} onHide={(e) => setModalShow(false)} centered className='CusModal'>
      <Modal.Header closeButton>
        <Modal.Title>Add Permission</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AddPermission modalClose={(e) => setModalShow(false)} addPermissionLocal={addPermissionLocal.bind(this)} />
      </Modal.Body>
    </Modal>
  </>);
}

export default withAdminAuth(UserPermissionList);